import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { EntityDetail } from '../../../common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '../../../common/entityFramework/entityForm/EntityForm';
import { TestResList } from '../testRes/TestResList';

export const TestRunDetail = () => {

  const { entityObj } = useEntityMgr();
  
  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'resTab', label: 'Results', content: <TestResList testRunId={entityObj.id} /> },
    { id: 'valTab', label: 'Validations', content: <ValList parentEntity="TEST_RUN" parentEntityId={entityObj.id} /> }
  ]
  
  return <EntityDetail tabSpecs={tabSpecs} />
}